import {Store, waitFor} from 'utils';
import SelectedPavilionStore from './SelectedPavilionStore';

class AboutStore extends Store {

	getInitialState() {
		return {
			data: {},
		}
	}

    onAboutDataChanged(state, data) {
        state.data = data;
    }
}

const store = new AboutStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/AboutStore.js